"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLogoImage = void 0;
var querystring_1 = __importDefault(require("querystring"));
var system_1 = require("../../../system");
var utils_1 = require("../../../utils");
var getLogoSrc = function (text, options) {
    var prams = {
        color: options === null || options === void 0 ? void 0 : options.color,
        // NOTE: IE fix (https://github.yandex-team.ru/soft/logoaas#svg-атрибут-viewbox)
        viewBox: 1,
    };
    return encodeURI("https://yastatic.net/q/logoaas/v2/".concat(text, ".svg?").concat(querystring_1.default.stringify(prams)));
};
var useLogoImage = function (text) {
    var _a;
    var theme = (0, system_1.useTheme)();
    var color = (0, utils_1.convertRGBAToHex)((_a = theme.go) === null || _a === void 0 ? void 0 : _a.schemes.colors.system.TextMain) || '';
    return getLogoSrc(text, { color: color.slice(1) });
};
exports.useLogoImage = useLogoImage;
